<template>
  <v-card outlined class="pa-3" style="background-color: #fafbfc; border-radius: 8px;">
    <div class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
      <v-icon color="secondary" class="mr-2">mdi-chart-box-outline</v-icon>
      <span>Helper de Proyección por Semana</span>
    </div>
    
    <div v-if="weeklyTotals.length > 0">
      <v-card 
        v-for="week in weeklyTotals" 
        :key="week.PdsID" 
        outlined 
        class="mb-3 pa-2 shadow-sm"
        style="border-color: #e2e8f0; border-radius: 6px; background-color: #ffffff;"
      >
        <div class="d-flex justify-space-between align-center mb-2 px-1">
          <span class="subtitle-2 font-weight-bold text--primary">{{ week.PdsName }}</span>
          <v-chip x-small color="primary" outlined>Vacantes: {{ reqQuantity }}</v-chip>
        </div>
        
        <table class="week-summary-table" style="width: 100%; border-collapse: collapse; font-size: 11.5px;">
          <thead>
            <tr style="border-bottom: 2px solid #cbd5e1; background-color: #f1f5f9; color: #475569;">
              <th class="text-left py-1 px-2">Turno</th>
              <th class="text-center py-1 px-2">Cant. Inicial</th>
              <th class="text-center py-1 px-2">M</th>
              <th class="text-center py-1 px-2">F</th>
              <th class="text-center py-1 px-2">Total Ajustado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(turn, idx) in week.turns" :key="idx" style="border-bottom: 1px solid #e2e8f0;">
              <td class="py-1 px-2">{{ turn.turnName }}</td>
              <td class="text-center py-1 px-2 font-weight-bold text--secondary">{{ turn.originalQty }}</td>
              <td class="text-center py-1 px-2">{{ turn.male }}</td>
              <td class="text-center py-1 px-2">{{ turn.female }}</td>
              <td class="text-center py-1 px-2 font-weight-medium">{{ turn.qty }}</td>
            </tr>
            <tr style="background-color: #f8fafc; font-weight: bold; border-top: 2px solid #cbd5e1;">
              <td class="py-1 px-2">Total</td>
              <td class="text-center py-1 px-2 text--secondary">{{ week.originalTotal }}</td>
              <td class="text-center py-1 px-2">{{ week.male }}</td>
              <td class="text-center py-1 px-2">{{ week.female }}</td>
              <td class="text-center py-1 px-2">
                <span :style="{ color: week.total > reqQuantity ? '#ef4444' : '#10b981' }">
                  {{ week.total }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </v-card>
    </div>
    <div v-else class="text-center py-6 text-muted font-italic" style="font-size: 13px;">
      No hay semanas seleccionadas.
    </div>
  </v-card>
</template>

<script>
export default {
  name: "SWeeklyStaffingHelper",
  props: {
    projections: {
      type: Array,
      default: () => []
    },
    reqQuantity: {
      type: Number,
      default: 0
    },
    periodsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    weeklyTotals() {
      const groups = {};
      const activeRows = this.projections.filter(r => r.SecStatus !== 0 && r.PdsID);

      activeRows.forEach(r => {
        const key = r.PdsID;
        if (!groups[key]) {
          groups[key] = {
            PdsID: key,
            PdsName: this.getPeriodName(key),
            originalTotal: 0,
            total: 0,
            male: 0,
            female: 0,
            turns: []
          };
        }
        groups[key].originalTotal += (Number(r.WprOriginalQty) || 0);
        groups[key].total += (Number(r.WprQuantityProject) || 0);
        groups[key].male += (Number(r.WprQuantityMale) || 0);
        groups[key].female += (Number(r.WprQuantityFemale) || 0);

        const turnName = r.TypeTurn === 1 || String(r.TypeTurn) === '1' ? 'Día' : r.TypeTurn === 2 || String(r.TypeTurn) === '2' ? 'Noche' : 'Mixto';
        groups[key].turns.push({
          turnName: turnName,
          originalQty: Number(r.WprOriginalQty) || 0,
          qty: Number(r.WprQuantityProject) || 0,
          male: Number(r.WprQuantityMale) || 0,
          female: Number(r.WprQuantityFemale) || 0
        });
      });

      return Object.values(groups);
    }
  },
  methods: {
    getPeriodName(pdsID) {
      if (!pdsID) return "";
      const period = this.periodsList.find(p => String(p.PdsID) === String(pdsID));
      return period ? period.PdsName : `Semana ${pdsID}`;
    }
  }
};
</script>
